export default "__VITE_ASSET__D$xH_jh8__"